var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'next-loading': _vm.show,
    'next-open': _vm.show,
    'next-loading-inline': _vm.show,
  },staticStyle:{"width":"100%"}},[(_vm.show)?_c('div',{staticClass:"next-loading-tip"},[_vm._m(0),_c('div',{staticClass:"next-loading-tip-content"},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_c('div',{staticClass:"next-loading-component next-loading-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-loading-indicator"},[_c('div',{staticClass:"next-loading-fusion-reactor"},[_c('span',{staticClass:"next-loading-dot"}),_c('span',{staticClass:"next-loading-dot"}),_c('span',{staticClass:"next-loading-dot"}),_c('span',{staticClass:"next-loading-dot"})])])
}]

export { render, staticRenderFns }